import React, {useState, useEffect} from 'react'
import { useQuery, useQueryClient } from 'react-query';
import { ToastContainer, toast } from 'react-toastify';
import { format } from "date-fns"
import { deleteManyPackingItems, updateManyPackingItem } from 'utils/packingItems';
import Pagination from 'utils/Pagination';
import LogsList from './LogsList';
import Skeleton from 'react-loading-skeleton'
import { Title } from 'utils/Title'
import Banner from "@leafygreen-ui/banner"
import { AuthContext } from "contexts/AuthContext"
import { SettingsContext } from 'contexts/SettingsContext'
import PageMainHeader from 'components/PageMainHeader';
import axios from 'axios';
import _ from "lodash";
import { errorHandler } from 'utils/errorHandler';

const title = 'Logs'
const limit = 10;

const fetchLogs = (page) => {
  return new Promise(async (resolve, reject) => {
    try {
      let results;
      if(window?.printflo_api) {
        results = await window.printflo_api._fetchLogs({page});
        if(_.isError(results)) throw results
      } else {
        try {
          const response = await axios.get("/api/log/", {params: {page, limit}})
          results = response?.data
          
        } catch (error) {
          throw error
        }
      }
      resolve(results);
    } catch (error) {
      reject(errorHandler(error));
      
    }
  })
}

export default function Logs() {
  const [page, setPage] = useState(1);
  const { settings } = React.useContext(SettingsContext);
  const { user } = React.useContext(AuthContext);

  const queryClient = useQueryClient();
  const { data: logs, isLoading, isError, error } = useQuery(["logs", page],
    async () => {
      return fetchLogs(page)
    }, {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
  })
  // console.log("- logs: ", logs);

  useEffect(() => {
    // logs?.docs && console.log("logs in hook: ");
    if (logs?.totalPages > page) {
      queryClient.prefetchQuery(
        ["logs", page + 1],
        () => fetchLogs(page+1),
        {
          keepPreviousData: true,
          refetchOnWindowFocus: false,
          staleTime: 1000 * 60 * 5,
        }
      );
    }
    // eslint-disable-next-line
  }, [logs, page, queryClient]);

  const handleOnPageChange = ({ selected }) => {
    console.log("* handleOnPageChange init")
    // console.log("- selected: ", selected);
    setPage(selected + 1);
  };

  const restorePickedQty = async (timestamp) => {
    console.log('* restorePickedQty init')
    console.log('- timestamp: ', timestamp)
    const confirm = window.confirm(`Confirm to restore picked quantity from ${format(new Date(timestamp), "MM-dd-yyy hh:mm:ss b")}`)
    if (confirm) {
      updateManyPackingItem({
        condition: { isActive: true, createdAt: { $gte: new Date(timestamp) } },
        update: {$set: {pickedQty: 0}}
      }).then(response => {
        console.log('- response: ', response)
        toast.info(`Successfully restored ${response?.nModified} packing item(s)`, {
          position: "bottom-right"
        })
      })
      
    }
  }

  const deletePackingItemsByTimestamp = async (timestamp, index) => {
    console.log('* deletePackingItemsByTimestamp init')
    console.log('- timestamp: ', timestamp)
    console.log('- index: ', index);
    let log = logs?.docs[index]
    console.log('- log: ', log);
    let condition = { createdAt: { $gte: new Date(timestamp) } }
    if(!_.isNil(log?.locationCode)) {
      condition["locationCode"] = log.locationCode
    }
    
    let msg = `Confirm to delete packing items from ${format(new Date(timestamp), "MM-dd-yyy hh:mm:ss b")}`;
    
    if(index > 0) {
      let nextIndex = index - 1;
      let nextLog = logs?.docs[nextIndex];
      console.log("[deletePackingItemsByTimestamp] nextLog: ", nextLog);
      if(nextLog?.timestamp) {
        condition = {createdAt: { $gte: new Date(timestamp), $lt: new Date(nextLog.timestamp) }};
        msg = msg + ` to ${format(new Date(nextLog.timestamp), "MM-dd-yyy hh:mm:ss b")}`
      }
    }
    console.log("[deletePackingItemsByTimestamp] condition: ", condition);
    
    const confirm = window.confirm(msg);
    if (confirm) {
      deleteManyPackingItems(condition).then(response => {
        console.log('[deletePackingItemsByTimestamp] response: ', response)
        
        toast.info(`Successfully deleted ${response?.deletedCount} packing item(s)`, {
          position: "bottom-right"
        })
      })
    }
  }

  return (
    <>
      <Title title={title} />
      <ToastContainer theme='dark' />
      <PageMainHeader 
        title={title} 
        user={user} 
        settings={settings} 
      />
      <section className="primary">
        {isLoading ? (
          <Skeleton count={20} height={50} circle={true} />
        ) : isError ? (
          <Banner variant='danger'>{error?.message ? error.message : error}</Banner>
        ) : (
          null
        )}
        {
          logs && <Pagination
          handleOnPageChange={handleOnPageChange}
          totalDocs={logs?.totalDocs}
          totalPages={logs?.totalPages}
          page={page}
          limit={limit}
          />
        }
        {
          logs?.docs && Boolean(logs.docs.length) 
          ? (<LogsList logs={logs.docs} restorePickedQty={restorePickedQty} deletePackingItemsByTimestamp={deletePackingItemsByTimestamp} />) 
          : ( <Banner variant="info">Logs not found</Banner>)
        }
      </section>
    </>
  )
}
